import restApi from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApi.post("/api/bom-version", params);
};

/* 전개에 적용할 수 있는 버전. getAll 은 버전을 소유한 품목의 버전이고, 이쪽은 반제품처럼 자기 버전이
   없는 품목까지 포함해 "이 품목을 전개할 때 쓸 수 있는 (완제품 × 버전)" 을 돌려준다. */
const getApplicable = params => {
  return restApi.post("/api/bom-version/applicable", params);
};

const upsert = data => {
  return restApi.post("/api/bom-version/save", data);
};

const copy = data => {
  return restApi.post("/api/bom-version/copy", data);
};

const remove = ids => {
  return restApi.delete(`/api/bom-version/${ids}`);
};

const bomVersionService = {
  getAll,
  getApplicable,
  upsert,
  copy,
  remove
};

export default bomVersionService;
